import React from "react";
import _ from "lodash";

import SelectFormElementV2 from "../../../../../formElement/SelectFormElementV2";
import {useInputStyles} from "./table_data";

const OPTIONS = [
  0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100
].map(d => ({id: d, value: d, label: `${d} %`}))

const PercentageInputField = ({value, onChange, maxValue, dataId}) => {
  const classes = useInputStyles();

  const options = React.useMemo(() => {
    return _.isNumber(maxValue) ? OPTIONS.filter(o => o.value <= maxValue) : OPTIONS
  }, [maxValue])

  return (
    <SelectFormElementV2
      value={value}
      options={options}
      onChange={onChange}
      required
      newDesign
      custom_classes={classes}
      dataId={dataId}
    />
  )
}

export default PercentageInputField;